import { getTextCorrectionSuggestion } from './textCorrection';

export const CLIENT_TEXT_GIBBERISH_MESSAGE =
  'This entry appears unclear or nonsensical. Please enter a meaningful response.';

const KEYBOARD_RUNS = [
  'qwertyuiop', 'poiuytrewq', 'asdfghjkl', 'lkjhgfdsa',
  'zxcvbnm', 'mnbvcxz',
];

// This is intentionally conservative and structural. It is not a dictionary
// check, so names, abbreviations, places, and transliterated words remain valid.
export const validateClientTextInput = (text) => {
  const normalized = String(text ?? '').normalize('NFKC').trim();
  if (!normalized) return { valid: true, reason: null };

  // A typo the local correction engine understands must reach that independent flow.
  if (getTextCorrectionSuggestion(normalized)) return { valid: true, reason: null };

  if (/^\p{N}+$/u.test(normalized)) return { valid: false, reason: 'numeric_only' };
  if (!/\p{L}/u.test(normalized)) return { valid: false, reason: 'symbols_only' };

  const letters = (normalized.match(/\p{L}/gu) || []).join('').toLocaleLowerCase();
  if (/(.)\1{5,}/u.test(letters)) return { valid: false, reason: 'repeated_character' };
  if (/^(.{1,3})\1{2,}$/u.test(letters)) return { valid: false, reason: 'repeated_pattern' };
  if (letters.length >= 6 && KEYBOARD_RUNS.some((row) => row.includes(letters))) {
    return { valid: false, reason: 'keyboard_sequence' };
  }
  if (/^[bcdfghjklmnpqrstvwxyz]{9,}$/i.test(letters)) {
    return { valid: false, reason: 'long_consonant_only' };
  }

  return { valid: true, reason: null };
};

